import React from 'react';
import { Pie } from '@ant-design/plots';

const PieChart = (props) => {
  // 折线图组件
  const {
    pieData = [],
    colorField = 'title',
    angleField = 'value',

    height = 300,
  } = props;

  if (!pieData) {
    return <></>;
  }

  const config = {
    data: pieData,
    angleField: angleField,
    colorField: colorField,
    appendPadding: 30,
    label: {
      text: 'value',
      style: {
        fontWeight: 'bold',
      },
    },
    legend: {
      color: {
        title: false,
        position: 'right',
        rowPadding: 5,
      },
    },
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '20rpx',
      }}
    >
      <Pie
        {...config}
        height={height}
        style={{
          maxWidth: '500px',
          width: '100%',
        }}
      />
    </div>
  );
};

export default PieChart;
